<template>
  <span class="bg-main-550 flex h-4 w-4 items-center justify-center rounded-full text-xs font-medium text-white">
    <slot />
  </span>
</template>
